"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const react_helmet_1 = __importDefault(require("react-helmet"));
const Button_1 = require("@Components/Buttons/Button");
const MatchRecordingGroups_1 = __importDefault(require("@App/kit/components/MatchComponents/MatchRecordingGroups"));
const ModalPortal_1 = __importDefault(require("@App/kit/components/Popups/ModalPortal"));
const contexts_1 = require("@App/contexts");
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const SearchWithCriteria_1 = __importDefault(require("@Components/Search/SearchWithCriteria"));
const form_field_types_1 = require("@App/enum/form-field-types");
const MatchSearchHeader_1 = __importDefault(require("@Scenes/RightsholderScene/MatchClaim/Match/MatchSearch/MatchSearchHeader"));
const MatchWorksPopup_1 = __importDefault(require("@Components/MatchComponents/MatchWorksPopup"));
const dropdown_options_1 = require("@Const/dropdown-options");
const pluralize_1 = __importDefault(require("pluralize"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const MatchSearch = (props) => {
    const { matchingStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { goToStep } = props;
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [modalIsOpen, setModalIsOpen] = (0, react_1.useState)(false);
    const recordingGroupsCount = matchingStore.selectedUnmatchedRecordingGroups.length;
    const matchSearchFilter = [
        {
            name: 'Estimated Value Filter',
            allowMultiple: false,
            filterFields: [
                {
                    claim: {
                        type: form_field_types_1.FormFieldTypes.DROPDOWN,
                        name: 'unmatchedValue',
                        label: 'Estimated Value',
                        placeholder: 'All values',
                        assistiveTextVisibility: { assistive: false },
                        options: dropdown_options_1.unmatchedValueOptions,
                        isClearable: true,
                    },
                },
            ],
        },
    ];
    const newSearch = (searchCriteria, filter) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        matchingStore.setMatchingSearchCriteria(searchCriteria);
        matchingStore.setMatchingFilterCriteria(filter);
        yield matchingStore.loadUnmatchedSearchResults(1);
        setLoading(false);
    });
    const moreResults = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield matchingStore.loadNextUnmatchedSearchResultsPage();
        setLoading(false);
    });
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_match_search');
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Matching Tool' }),
        react_1.default.createElement("div", { className: 'global-container' },
            react_1.default.createElement("div", { className: "match-search-wrapper" },
                react_1.default.createElement(ContentHeader_1.default, { title: 'Matching Tool', descriptionElement: react_1.default.createElement(MatchSearchHeader_1.default, null) }),
                react_1.default.createElement("div", { className: "matching-tool" },
                    react_1.default.createElement(SearchWithCriteria_1.default, { searchCriteriaStore: matchingStore.searchCriteriaStore, canAddCriteria: true, handleSearch: newSearch, disableSearchButtons: loading, filterFieldCollections: matchSearchFilter }),
                    react_1.default.createElement("div", { className: "match-claim-table" },
                        react_1.default.createElement(MatchRecordingGroups_1.default, { loadMore: moreResults, loading: loading })),
                    recordingGroupsCount > 0 && (react_1.default.createElement(Button_1.Button, { mainColor: true, className: "match-button", type: "primary", onClick: () => setModalIsOpen(true) },
                        "Match ",
                        (0, pluralize_1.default)('Group', recordingGroupsCount, true))),
                    react_1.default.createElement(ModalPortal_1.default, { isOpen: modalIsOpen },
                        react_1.default.createElement(MatchWorksPopup_1.default, { recordingGroupsCount: recordingGroupsCount, onCancel: () => setModalIsOpen(false), onContinue: () => goToStep(2) })))))));
};
exports.default = (0, mobx_react_1.observer)(MatchSearch);
